import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconCheckeredSg = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={12}
    fill="none"
    viewBox="0 0 13 12"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-checkered-sg_svg__a)"
      d="M12.18.023c.422 0 .82.282.82.704v7.078c0 .28-.188.539-.469.656C11.523 8.859 10.703 9 10 9c-1.688 0-2.836-.727-4.5-.727-.844 0-1.805.188-3 .727v2.625c0 .21-.188.375-.375.375h-.773a.385.385 0 0 1-.375-.375L1 .75c0-.398.328-.75.75-.75.398 0 .75.352.75.75v.023C3.836.211 4.82.023 5.594.023c1.57 0 2.343.75 3.703.75.656 0 1.406-.164 2.437-.656.141-.07.305-.094.446-.094Zm-.68 3.305V1.852c-.68.234-1.29.375-1.875.398v1.617c-.117 0-.234.024-.328.024-.586 0-1.078-.141-1.547-.305V2.039a9.976 9.976 0 0 1-.633-.21c-.445-.141-.82-.259-1.242-.282V3.14h-.281c-.446 0-.985.07-1.594.234V1.828c-.305.07-.61.188-.938.328l-.562.235v1.5A10.416 10.416 0 0 1 4 3.375v1.922c-.305.094-.61.21-.938.351l-.562.235v1.5A9.216 9.216 0 0 1 4 6.914V5.297c.586-.188 1.125-.281 1.594-.281h.281v1.78c.68.024 1.313.141 1.875.282V5.531c.445.117.938.235 1.547.235.117 0 .21-.024.328-.024V7.5h.352c.492 0 .984-.07 1.523-.258V5.344c-.68.234-1.29.375-1.875.398V3.867c.516-.047 1.125-.21 1.875-.539Zm-5.625-.187c.727.046 1.313.257 1.875.445V5.53a9.982 9.982 0 0 1-.633-.21c-.445-.141-.82-.258-1.242-.305V3.14Z"
    />
    <defs>
      <linearGradient
        id="icon-checkered-sg_svg__a"
        x1={13}
        x2={2.042}
        y1={0.5}
        y2={12.455}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.18} stopColor="#EEE" />
        <stop offset={0.73} stopColor="#A0A0A0" />
        <stop offset={1} stopColor="#979797" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconCheckeredSg;
